export default __webpack_public_path__ + "static/media/hedwig-step-3.da79431a.png";